<ng-container *ngIf="filterService.filters$ | async as activeFilters">
  <ng-container *ngIf="$any(activeFilters) as activeFilters">
  <div *ngIf="isFilterVisible('suburb')">
    <div class="filter-box-section">
      <div class="filter-box-title">{{ 'label.tourinform.Destination' | translate }}</div>
      <!-- <button class="clear-all-filter" *ngIf="filterActive(activeFilters.suburb)" (click)="onClearFilter('suburb')">
        <i class="icon icon-close-red"></i>
        {{ 'label.clear-filter' | translate }}
      </button> -->
      <ng-container *ngFor="let filterOption of sortFilterOptionsByText(activeFilters.suburb)">
        <div class="option" (click)="onOptionClick(filterOption)">
          <div class="checker" [ngClass]="{ checked: filterOption.checked }">
            <div class="check"></div>
          </div>
          <span class="text">{{ getSuburbDisplayText(filterOption) }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <hr *ngIf="isFilterVisible('suburb')" />
  <ng-container
    *ngIf="
      isAccommodationCampaign &&
      shouldShowRange(activeFilters?.priceRange) &&
      isFilterVisible('priceRange')
    "
  >
    <span>
      HUF {{ priceRangeDisplayStart || activeFilters.priceRange.start }} - HUF {{ priceRangeDisplayEnd || activeFilters.priceRange.end }}
    </span>
    <br />
    <mat-slider
      [min]="activeFilters.priceRange.min"
      [max]="getPriceRangeSliderMax(activeFilters.priceRange)"
      [step]="1000"
      (change)="onPriceRangeChange()"
    >
      <input [value]="activeFilters.priceRange.start" matSliderStartThumb (input)="onPriceRangeInput($event, 'start')" />
      <input [value]="activeFilters.priceRange.end" matSliderEndThumb (input)="onPriceRangeInput($event, 'end')" />
    </mat-slider>
  </ng-container>

  <hr
    *ngIf="
      isAccommodationCampaign &&
      shouldShowRange(activeFilters?.priceRange) &&
      isFilterVisible('priceRange')
    "
  />

  <ng-container *ngIf="isFilterVisible('city')">
    <div class="filter-box-section">
      <div
        class="filter-box-title dropdown"
        [ngClass]="{ 'arrow-up': isCityFilterOpen, 'arrow-down': !isCityFilterOpen }"
        (click)="isCityFilterOpen = !isCityFilterOpen"
      >
        {{ 'label.filter-destination-placeholder' | translate }}
      </div>
      <!-- <button class="clear-all-filter" *ngIf="filterActive(activeFilters.city)" (click)="onClearFilter('city')">
        <i class="icon icon-close-red"></i>
        {{ 'label.clear-filter' | translate }}
      </button> -->
      <div class="options scrollable" [ngClass]="{ opened: isCityFilterOpen }">
        <ng-container *ngFor="let filterOption of sortFilterOptionsByText(activeFilters.city)">
          <div class="option" (click)="onOptionClick(filterOption)">
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text">{{ filterOption.text }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <hr *ngIf="isFilterVisible('city')" />

   <ng-container *ngIf="activeFilters?.acceptsCardType?.length">
    <div class="filter-box-section">
      <div class="filter-box-title">SZÉP Card</div>
<!--   <button class="clear-all-filter" *ngIf="filterActive(activeFilters.acceptsCardType)" (click)="onClearFilter('acceptsCardType')">
        <i class="icon icon-close-red"></i>
        {{ 'label.clear-filter' | translate }}
      </button>-->
   <ng-container *ngFor="let filterOption of activeFilters.acceptsCardType">
        <div class="option" (click)="onOptionClick(filterOption)">
          <div class="checker" [ngClass]="{ checked: filterOption.checked }">
            <div class="check"></div>
          </div>
          <span class="text">{{ filterOption.text }}</span>
        </div>
      </ng-container>
    </div>
  </ng-container>
  <hr />

  <ng-container *ngIf="isFilterVisible('accommodationType')">
    <div class="filter-box-section">
      <div
        class="filter-box-title dropdown"
        [ngClass]="{ 'arrow-up': isaccommodationTypeFilterOpen, 'arrow-down': !isaccommodationTypeFilterOpen }"
        (click)="isaccommodationTypeFilterOpen = !isaccommodationTypeFilterOpen"
      >
        {{ 'ATTRACTION.type' | translate }}
      </div>
      <!-- <button class="clear-all-filter" *ngIf="filterActive(activeFilters.accommodationType)" (click)="onClearFilter('accommodationType')">
        <i class="icon icon-close-red"></i>
        {{ 'label.clear-filter' | translate }}
      </button> -->
      <div class="options" [ngClass]="{ opened: isaccommodationTypeFilterOpen }">
        <ng-container *ngFor="let filterOption of activeFilters.accommodationType">
          <div class="option" (click)="onOptionClick(filterOption)">
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text">{{ filterOption.text }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <hr *ngIf="isFilterVisible('accommodationType')" />

  <ng-container *ngIf="isFilterVisible('accommodationClass') && !isOnlyNonClassifiedSelected(activeFilters)">
    <div class="filter-box-section">
      <div
        class="filter-box-title accommodation-class dropdown"
        [ngClass]="{ 'arrow-up': isaccommodationClassFilterOpen, 'arrow-down': !isaccommodationClassFilterOpen }"
        (click)="isaccommodationClassFilterOpen = !isaccommodationClassFilterOpen"
      >
        {{ 'CAMPAIGN.accommodation-class' | translate }}
      </div>
      <!-- <button class="clear-all-filter" *ngIf="filterActive(activeFilters.accommodationClass)" (click)="onClearFilter('accommodationClass')">
        <i class="icon icon-close-red"></i>
        {{ 'label.clear-filter' | translate }}
      </button> -->
      <div class="options" [ngClass]="{ opened: isaccommodationClassFilterOpen }">
        <ng-container *ngFor="let filterOption of activeFilters.accommodationClass; let i = index">
          <div
            class="option"
            *ngIf="
              (!isHotelSelected(activeFilters) && !isaccommodationTypeUnchecked(activeFilters) && (i + 1) % 2 !== 0) ||
              isHotelSelected(activeFilters) ||
              isaccommodationTypeUnchecked(activeFilters)
            "
            (click)="onOptionClick(filterOption)"
          >
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text accommodation-class">{{ accommodationClassText(filterOption.text) }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <hr *ngIf="isFilterVisible('accommodationClass') && !isOnlyNonClassifiedSelected(activeFilters)" />

  <ng-container *ngIf="isFilterVisible('accommodationFeature')">
    <div class="filter-box-section">
      <div
        class="filter-box-title dropdown"
        [ngClass]="{ 'arrow-up': isAccommodationFeatureFilterOpen, 'arrow-down': !isAccommodationFeatureFilterOpen }"
        (click)="isAccommodationFeatureFilterOpen = !isAccommodationFeatureFilterOpen"
      >
        {{ 'label.tourinform.Features' | translate }}
      </div>
      <div class="options" [ngClass]="{ opened: isAccommodationFeatureFilterOpen }">
        <ng-container *ngFor="let filterOption of activeFilters.accommodationFeature">
          <div class="option" (click)="onOptionClick(filterOption)">
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text">{{ filterOption.text }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <hr *ngIf="isFilterVisible('accommodationFeature')" />

  <ng-container *ngIf="isFilterVisible('accommodationService')">
    <div class="filter-box-section">
      <div
        class="filter-box-title dropdown"
        [ngClass]="{ 'arrow-up': isAccommodationServiceFilterOpen, 'arrow-down': !isAccommodationServiceFilterOpen }"
        (click)="isAccommodationServiceFilterOpen = !isAccommodationServiceFilterOpen"
      >
        {{ 'ATTRACTION.services' | translate }}
      </div>
      <div class="options" [ngClass]="{ opened: isAccommodationServiceFilterOpen }">
        <ng-container *ngFor="let filterOption of activeFilters.accommodationService">
          <div class="option" (click)="onOptionClick(filterOption)">
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text">{{ filterOption.text }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <hr *ngIf="isFilterVisible('accommodationService')" />

  <ng-container *ngIf="isFilterVisible('campaignOffers')">
    <div class="filter-box-section">
      <div
        class="filter-box-title dropdown"
        [ngClass]="{ 'arrow-up': isCampaignOffersFilterOpen, 'arrow-down': !isCampaignOffersFilterOpen }"
        (click)="isCampaignOffersFilterOpen = !isCampaignOffersFilterOpen"
      >
        {{ 'COLLECTION.discount-type' | translate }}
      </div>
      <div class="options" [ngClass]="{ opened: isCampaignOffersFilterOpen }">
        <ng-container *ngFor="let filterOption of activeFilters.campaignOffers">
          <div class="option" (click)="onOptionClick(filterOption)">
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text">{{ filterOption.text }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>

  <hr *ngIf="isFilterVisible('campaignOffers')" />

  <ng-container *ngIf="shouldShowRange(activeFilters?.discountPercent) && isFilterVisible('discountPercent')">
    <div class="filter-box-title">
      {{ 'COLLECTION.discount-amount' | translate }} <span>({{ discountPercentDisplayStart }}% - {{ discountPercentDisplayEnd }}%)</span>
    </div>
    <mat-slider
      [min]="activeFilters.discountPercent.min"
      [max]="activeFilters.discountPercent.max"
      [step]="1"
      (change)="onDiscountPercentChange()"
    >
      <input
        [value]="activeFilters.discountPercent.start"
        matSliderStartThumb
        (input)="onDiscountPercentInput($event, 'start')"
      />
      <input
        [value]="activeFilters.discountPercent.end"
        matSliderEndThumb
        (input)="onDiscountPercentInput($event, 'end')"
      />
    </mat-slider>
  </ng-container>

  <hr *ngIf="shouldShowRange(activeFilters?.discountPercent) && isFilterVisible('discountPercent')" />

  <div *ngIf="isAccommodationCampaign && isFilterVisible('accommodationNature')" class="filter-box-section">
    <div
      class="filter-box-title dropdown"
      [ngClass]="{ 'arrow-up': isaccommodationNatureFilterOpen, 'arrow-down': !isaccommodationNatureFilterOpen }"
      (click)="isaccommodationNatureFilterOpen = !isaccommodationNatureFilterOpen"
    >
      {{ 'label.tourinform.Type' | translate }}
    </div>
    <div class="options" [ngClass]="{ opened: isaccommodationNatureFilterOpen }">
      <ng-container *ngFor="let option of accommodationNatureOptions">
        <div class="option" (click)="onAccommodationNatureToggle(option.key)">
          <div class="checker" [ngClass]="{ checked: activeFilters.accommodationNature[option.key] }">
            <div class="check"></div>
          </div>
          <span class="text">{{ option.label | translate }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <hr *ngIf="isAccommodationCampaign && isFilterVisible('accommodationNature')" />

  <ng-container *ngIf="isFilterVisible('paymentMethod')">
    <div class="filter-box-section">
      <div
        class="filter-box-title dropdown"
        [ngClass]="{ 'arrow-up': isPaymentMethodFilterOpen, 'arrow-down': !isPaymentMethodFilterOpen }"
        (click)="isPaymentMethodFilterOpen = !isPaymentMethodFilterOpen"
      >
        {{ 'label.payment-options' | translate }}
      </div>
      <div class="options" [ngClass]="{ opened: isPaymentMethodFilterOpen }">
        <ng-container *ngFor="let filterOption of activeFilters.paymentMethod">
          <div class="option" (click)="onOptionClick(filterOption)">
            <div class="checker" [ngClass]="{ checked: filterOption.checked }">
              <div class="check"></div>
            </div>
            <span class="text">{{ filterOption.text }}</span>
          </div>
        </ng-container>
      </div>
    </div>
  </ng-container>
  <hr *ngIf="isFilterVisible('paymentMethod')" />

  <div *ngIf="isAccommodationCampaign && isFilterVisible('equipment')" class="filter-box-section">
    <div
      class="filter-box-title dropdown"
      [ngClass]="{ 'arrow-up': isEquipmentFilterOpen, 'arrow-down': !isEquipmentFilterOpen }"
      (click)="isEquipmentFilterOpen = !isEquipmentFilterOpen"
    >
      {{ 'label.tourinform.equipment-rental' | translate }}
    </div>
    <div class="options" [ngClass]="{ opened: isEquipmentFilterOpen }">
      <ng-container *ngFor="let option of equipmentOptions">
        <div class="option" (click)="onEquipmentToggle(option.key)">
          <div class="checker" [ngClass]="{ checked: activeFilters.equipment[option.key] }">
            <div class="check"></div>
          </div>
          <span class="text">{{ option.label | translate }}</span>
        </div>
      </ng-container>
    </div>
  </div>
  <hr *ngIf="isAccommodationCampaign && isFilterVisible('equipment')" />
  </ng-container>
</ng-container>
